import React, { Fragment } from 'react';
import Carousel from "react-multi-carousel";

const LightboxImagesAccessories = ((props) => {
    let settings = {
        infinite: false,
        swipeable: true,
        draggable: true,
        showDots: false,
        arrows: true,
        responsive: {
            mobile: {
                breakpoint: { max: 10000, min: 0 },
                items: 1,
                slidesToSlide: 1,
            }
        },
        keyBoardControl: true,
        transitionDuration: 300,
        itemClass: "carousel-item",
        partialVisible: false,
        minimumTouchDrag: 10,
        renderButtonGroupOutside: true
    };
     return (
        <Fragment>
            <div className={'slideshow-overlay slideshow-overlay--visible accessory-image'} onClick={(e) => { if (e.target.classList.contains('react-multi-carousel-item')) { props.onClick(null) } }}>
                {
                    <div>
                        <a className="slideshow-close" onClick={() => { props.onClick(null) }}>
                            <svg><use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use></svg>
                        </a>
                        {/* <Carousel {...settings}>
                            {props.images.map((item, index) => {
                                return (
                                    <Fragment key={index}>
                                        <div className={'slideshow-item' + (item.iframe ? ' slideshow-item--iframe' : ' slideshow-item--photo')}>
                                            {item.iframe === 'true' ? (
                                                <iframe src={item.src} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                            ) : (
                                                    // <img className="slideshow-image" draggable="false" src={item.src} />
                                                    <div className="slideshow-image" dangerouslySetInnerHTML={{ __html: item.lightBoxHtml }}></div>

                                                )}
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </Carousel> */}
                        <Carousel {...settings}>
                            <div className={'slideshow-item' + (props.images.iframe ? ' slideshow-item--iframe' : ' slideshow-item--photo')}>
                                {props.images.iframe === 'true' ? (
                                    <iframe src={props.images.src} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                ) : (
                                        // <img className="slideshow-image" draggable="false" src={item.src} />
                                        <div className="slideshow-image" dangerouslySetInnerHTML={{ __html: props.images.lightBoxHtml }}></div>

                                    )}
                            </div>
                        </Carousel>
                    </div>
                }
            </div>
        </Fragment>
    )
})

export default LightboxImagesAccessories;